import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const customPracticeQueueBoardRoute: InvariantJiraRoute = {
	name: 'servicedesk-queues-practice-custom-board',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/:queueId/board/:boardId',
	exact: true,
};
